/**
 * The chat token route lives at the root of Django (`/api/chat/token`). The
 * base API url has no `/api` locally and on QA, and has it in production, so
 * the route is built from the origin.
 */
export function chatTokenUrl(baseApiUrl: string): string {
  const origin = baseApiUrl.replace(/\/+$/, '').replace(/\/api$/, '')

  return `${origin}/api/chat/token`
}
